import { createBrowserHistory as createHistory } from 'history';
import { deepMerge, deepEqual } from './utils';
import matrix from './matrix';

export default class Router {
  state = {};

  listeners = {
    onRoute: [],
    onBlock: [],
  };

  constructor({ basename, defaultState = {}, order = [] }) {
    this.defaultState = defaultState;
    this.order = order;

    this.onRoute = this.expose('onRoute');

    this.history = createHistory({
      basename,
    });

    const currentState = matrix.parse(this.history.location);
    const initialState = deepMerge(this.defaultState, currentState);

    this.history.listen(location => {
      this.state = matrix.parse(location);
      this.onRoute(this.state);
    });

    if (deepEqual(initialState, currentState)) {
      this.state = currentState;
    } else {
      this.replace(initialState);
    }
  }

  expose = action => (...args) => {
    const actionListeners = this.listeners[action];
    actionListeners.forEach(listener => listener(...args));
  };

  replace = (userState = {}, merge = true) => {
    const newState = deepMerge(this.defaultState, merge ? this.state : {}, userState);
    const url = matrix.stringify(newState, this.order);
    this.history.replace(url);
  };

  push = (userState = {}, merge = true) => {
    const newState = deepMerge(this.defaultState, merge ? this.state : {}, userState);
    const url = matrix.stringify(newState, this.order);
    this.history.push(url);
  };

  back = (...args) => this.history.goBack(...args);

  block = (...args) => this.history.block(...args);

  unsubscribe = (event, listener) => {
    const index = this.listeners[event].indexOf(listener);
    index > -1 && this.listeners[event].splice(index, 1);
  };

  subscribe = (event, listener) => {
    this.listeners[event].push(listener);
    event === 'onRoute' && listener(this.state);
    return this.unsubscribe.bind(this, event, listener);
  };

  getCookieValue = key => document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1');
}
